module.exports = __webpack_public_path__ + "img/hexagon-plus.9df9e286.svg";